import { Button, Card, Link, Loading, Text } from "@nextui-org/react";
import {
  usePrepareContractWrite,
  useContractWrite,
  useWaitForTransaction,
  useAccount,
} from "wagmi";

import ROYALTIES_ABI from "../abi/GhoulsRoyalties.json";

export function ReleaseWeth() {
  const wethAddress = "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2";
  const { address, isConnecting, isDisconnected } = useAccount();
  const {
    config,
    error: prepareError,
    isError: isPrepareError,
  } = usePrepareContractWrite({
    addressOrName: "0x283FCF59FCEb9Da8AB7F94bc1dDC294164885d9C",
    contractInterface: ROYALTIES_ABI,
    functionName: "release(address,address)",
    args: [wethAddress, address],
  });
  const { data, error, isError, write } = useContractWrite(config);

  const { isLoading, isSuccess } = useWaitForTransaction({
    hash: data?.hash,
  });

  if (isConnecting) return <div>Connecting...</div>;
  if (isDisconnected) return <div>Disconnected</div>;

  return (
    <div>
      <Button
        shadow
        color="primary"
        auto
        disabled={!write || isLoading}
        onClick={() => write?.()}
      >
        {isLoading ? (
          <Loading color="currentColor" size="sm" />
        ) : (
          "Release Wrapped ETH"
        )}
      </Button>
      {isSuccess && (
        <div>
          WETH Released!
          <Link>
            <a href={`https://etherscan.io/tx/${data?.hash}`}>Etherscan</a>
          </Link>
        </div>
      )}
      {isError && (
        <>
          <Card css={{ mw: "400px" }}>
            <Card.Body>
              <Text>Contract Error: {(prepareError || error)?.message}</Text>
            </Card.Body>
          </Card>
        </>
      )}
    </div>
  );
}
